import {CanDeactivateFn} from '@angular/router';

/** Implemented by components that want to block navigation while they hold unsaved edits. */
export interface ComponentCanDeactivate {
  hasUnsavedChanges(): boolean;
}

/**
 * Route guard that prompts the user before leaving a component with unsaved
 * changes. Components opt in by implementing {@link ComponentCanDeactivate}.
 */
export const unsavedChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = (component) => {
  if (component && typeof component.hasUnsavedChanges === 'function' && component.hasUnsavedChanges()) {
    return confirm('Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?');
  }
  return true;
};
